import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'status',
    state: {
        mataUang: [],
    },
    getters: {
        getAllMataUang: state => {
            return state.mataUang
        },
    },
    mutations: {
        GET_ALL_MATA_UANG: (state, payload) => {
            state.mataUang = payload
        }
    },
    actions: {
        async FETCH_ALL_MATA_UANG(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "mata_uang",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('GET_ALL_MATA_UANG', response.data.data);
                return store.state.mataUang;
            })
                .catch(err => {
                    return err
                });
        },
    }
}